import { FC, useEffect } from 'react';
import { ModalComponentBaseProps } from '@pcmp/react-providers';
import { Sheets, ModalBody } from '@ingka/modal';
import { useContentTracking } from '@/lib/hooks/tracking';
import { usePathname } from '@/lib/router';
import { getShopPath } from '@/lib/utils/router';
import {
  AdminSideMenu,
  MainSideMenu,
  WebshopSideMenu,
} from '@/components/layouts/page-layout/menu';
import { useLayoutContext } from '@/components/layouts/context';
import { PageLeftNavigationMenuTitle } from '@/components/layouts/page-webshop';
import { Navigation } from '@pcmp/react-coworker-components';
import styles from './index.module.css';

const { SideNavigation } = Navigation;

const PageLayoutMenuSider: FC<ModalComponentBaseProps> = ({
  handleDismiss,
  ...rest
}) => {
  // Hooks
  const trackContent = useContentTracking();
  const pathname = usePathname() || '';
  const { isAdminLayout } = useLayoutContext();
  // Data
  const isWebshop = pathname.includes(getShopPath());
  const MenuComponent =
    isAdminLayout || pathname.includes('/admin')
      ? AdminSideMenu
      : isWebshop
      ? WebshopSideMenu
      : MainSideMenu;

  useEffect(() => {
    trackContent('page-layout-menu', { type: 'sider' });
  }, []);

  return (
    <Sheets
      {...rest}
      data-testid="pageLayoutMenuSider"
      alignment="left"
      footer={null}
      header={null}
    >
      <ModalBody>
        <SideNavigation
          title={<PageLeftNavigationMenuTitle />}
          className={`h-full pt-8 overflow-auto ${styles['full-width']}`}
        >
          <MenuComponent />
        </SideNavigation>
      </ModalBody>
    </Sheets>
  );
};

export default PageLayoutMenuSider;
